import service from './Setting'


export const GetOfferDetailSub = (obj) => service.get('/Offer/GetOfferDetailSub',{ params: { ...obj} });

export const GetOfferDetail = (obj) => service.post('/Offer/GetOfferDetail',obj);


export const GetGetByRandomId= (obj) => service.get('/ExternalPersonBuffer/GetByRandomId',{ params: { ...obj} });


